const LOGO_PRESENT_OPTIONS = [
   {
      value: 'all',
      label: 'All',
      id: 'all',
      name: 'All',
   },
   {
      value: 'yes',
      label: 'Yes',
      id: 'yes',
      name: 'Yes',
   },
   {
      value: 'no',
      label: 'No',
      id: 'no',
      name: 'No',
   },
];

export default LOGO_PRESENT_OPTIONS;
